import React from "react";
import styles from "./TireSizeButtons.module.scss";
import Button from "@components/atoms/Button";

interface TireSizeButtonsProps {
  tyreCode: string;
  classType?:string;
  active?: boolean;
  onClick?: () => void;
}

export default function TireSizeButtons({
  tyreCode,
  active,
  classType,  
  onClick
}: TireSizeButtonsProps) {
  return (
    <Button
    onButtonClick={onClick}
      variant={active ? "secondary" : "outline"}
      className={!active ? styles.button : styles.outline + " " + classType}
    >
      {tyreCode}
    </Button>
  );
}
